(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ck-usp-drawers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ck-shipping-benefits')) {
  customElements.define('ck-shipping-benefits', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-shipping-variants]').textContent);
      this.scope = this.closest('.shopify-section') || document;
      this.update = () => {
        const selected = this.scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value || this.dataset.defaultVariant;
        const free = this.dataset.countryEligible === 'true' && this.variants[selected] === true;
        this.querySelector('[data-free-shipping]').hidden = !free;
        this.querySelector('[data-paid-shipping]').hidden = free;
      };
      this.onChange = () => {
        clearTimeout(this.changeTimer);
        clearTimeout(this.settleTimer);
        this.changeTimer = setTimeout(this.update, 300);
        this.settleTimer = setTimeout(this.update, 1000);
      };
      this.scope.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.update();
      });
      this.observer.observe(this.scope, {childList:true, subtree:true, attributes:true, attributeFilter:['value']});
      this.update();
    }
    disconnectedCallback() {
      clearTimeout(this.changeTimer);
      clearTimeout(this.settleTimer);
      this.scope?.removeEventListener('change', this.onChange);
      this.observer?.disconnect();
    }
  });
}


if(!customElements.get('ck-klarna-info')){
customElements.define('ck-klarna-info',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const dialog=this.querySelector('dialog'),trigger=this.querySelector('.ck-klarna-trigger');
const prices=JSON.parse(this.querySelector('[data-prices]').textContent);
trigger.addEventListener('click',()=>{
const scope=this.closest('.shopify-section')||document;
const id=scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value||this.dataset.variant;
const price=prices[id]??prices[this.dataset.variant];
this.querySelector('[data-amount]').textContent=new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}).format(price/300);
dialog.showModal();
});
this.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
dialog.addEventListener('click',event=>{const r=dialog.getBoundingClientRect();if(event.target===dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))dialog.close()});
dialog.addEventListener('close',()=>trigger.focus());
}
});
}
  } catch(e) { console.error(e); }
})();

})();
